export default __webpack_public_path__ + "media/images/confirm-01bc6c141b0d7ba6e05384e80d026501.png";